import React, { useState } from 'react';
import {
  TopToolbar,
  FilterButton,
  Button,
} from 'react-admin';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

import UploadMarkdownsDialog from './UploadMarkdownsDialog';
import { CreateOverrideTemplateDialog } from './createOverrideTemplate';

const ItemAdjustedPricesActions = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [isTemplateOpen, setIsTemplateOpen] = useState(false);

  return (
    <TopToolbar sx={{ flex: 'none' }}>
      <FilterButton />
      <Button
        label="Create Override Template"
        onClick={() => setIsTemplateOpen(true)}
        startIcon={<NoteAddIcon />}
      />
      <CreateOverrideTemplateDialog
        open={isTemplateOpen}
        onClose={() => setIsTemplateOpen(false)}
      />
      <Button
        label="Upload markdowns"
        onClick={() => setIsUploadOpen(true)}
        startIcon={<FileUploadIcon />}
      />
      <UploadMarkdownsDialog
        open={isUploadOpen}
        onClose={() => setIsUploadOpen(false)}
      />
    </TopToolbar>
  );
};

export default ItemAdjustedPricesActions;
